/** @format */

import React from 'react';
import Profile from './Profile';
import SectionWrapper from './SectionWrapper';
import Jobs from './Jobs';
import classNames from 'classnames';
import styles from './sections.module.css';
import Contacts from './Contacts/Contacts';

function index() {
  return (
    <SectionWrapper>
      <Profile />
      <div className={classNames(styles['profile-jobs-gap'])}></div>
      <Jobs />
      <Contacts />
    </SectionWrapper>
  );
}

export default index;
